import { Navigate, Outlet, useLocation } from 'react-router-dom';
import useAuth from 'hooks/useAuth';
import { useMemo } from 'react';

interface MenuAccess {
  [key: string]: boolean;
}

const ProtectedRoute: React.FC = () => {
  const { isLoggedIn, user } = useAuth() as { isLoggedIn: boolean; user?: any };
  const rawAccess = localStorage.getItem('userAccess');
  const menuAccess: MenuAccess = rawAccess ? JSON.parse(rawAccess) : {};

  const location = useLocation();
  const storedUser = useMemo(() => {
    try {
      return JSON.parse(localStorage.getItem('userInformation') || 'null');
    } catch {
      return null;
    }
  }, []);
  const resolvedActiveUser =
    (storedUser && storedUser.city ? storedUser : null) ||
    (user as any) ||
    storedUser ||
    {};
  const activeUser = resolvedActiveUser;
  const isConsultant = Boolean(
    activeUser?.Consultant?.isConsultant ||
      activeUser?.isConsultant ||
      String(activeUser?.userType || '').toLowerCase().includes('consult')
  );
  const hasActiveCity = Boolean(activeUser?.city);

  if (!isLoggedIn) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  const pathname = location.pathname.replace(/^\//, '').split('/')[0];

  if (menuAccess[pathname] === false) {
    return <Navigate to="/maintenance/403" replace />;
  }

  if ((pathname === '' || pathname === 'overview') && isConsultant && !hasActiveCity) {
    // eslint-disable-next-line no-console
    console.log('ProtectedRoute redirecting consultant away from overview', { isConsultant, hasActiveCity, activeUser });
    return <Navigate to="/consultant" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
